import _get from 'lodash/get';

// for controlling use of createDeliveriesV2, skip this flag for now
export const enableCreateOrderV2 = () =>
  _get(window.Grab, 'config.features.enableCreateDeliveriesV2', false);

// set default to true as already fully rolled out UI V2
// unless changed from UCM user configuration
export const enableUIV2 = () =>
  _get(window.Grab, 'config.features.enableUIV2', true);

export const enableWaybill = () => true;

export const enableCancellationRules = () =>
  _get(window.Grab, 'config.features.enableCancellationRules', false);
